import { render, staticRenderFns } from "./BaseGoto.vue?vue&type=template&id=8306a5ec&"
import script from "./BaseGoto.vue?vue&type=script&lang=js&"
export * from "./BaseGoto.vue?vue&type=script&lang=js&"
import style0 from "./BaseGoto.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFadeTransition,VHover,VIcon,VLayout})
